<div class="go-container">
  <go-card class="go-column go-column--100" id="full-example">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Full Example</h2>
      <go-copy cardId="full-example" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>
      <div class="go-column go-column--100 go-column--no-padding">
        <p class="go-body-copy">
          This example shows the GoLayout, GoSideNav, GoHeader, and GoSearch components in a cohesive example.
        </p>
        
        <h4 class="go-heading-4">app.module</h4>
        <code [highlight]="example_app_module"></code>
        
        <h4 class="go-heading-4">app.component.html</h4>
        <code [highlight]="example_app_html"></code>

        <h4 class="go-heading-4">app.component.ts</h4>
        <code [highlight]="example_app_ts"></code>
        
        <h4 class="go-heading-4">search-test.component.ts</h4>
        <code [highlight]="example_search_ts"></code>

        <h4 class="go-heading-4">search-test.component.html</h4>
        <code [highlight]="example_search_html"></code>
      </div>
    </div>
  </go-card>
</div>
